export type AnyCase<T extends string> = T | Uppercase<T> | Lowercase<T>

export const SortDirection = {
  ASC: 'asc',
  DESC: 'desc',
} as const

export type SortDirection = AnyCase<(typeof SortDirection)[keyof typeof SortDirection]>

export interface SortingParams {
  sortBy?: string
  sort?: SortDirection
}

export interface CursorPaginationParams extends SortingParams {
  cursor?: string
  limit?: number
}

export interface CursorPaginationMetadata extends SortingParams {
  previous?: string
  next?: string
  limit: number
}

export interface PaginationMetadataWithTotal extends CursorPaginationMetadata {
  totalItems: number
}

export interface CursorPaginationResponse<
  T,
  U extends CursorPaginationMetadata = CursorPaginationMetadata,
> {
  metadata: U
  data: T[]
}
